<template>
  <h1 class="text-sm">
    <slot> </slot>
  </h1>
</template>

<script>
export default {
  name: "MediumTitle",
  components: {},
};
</script>

<style>
</style>